import { ExpressionValue } from "../../ExpressionValue";
import { BaseStringExpression } from "./BaseString";
import { StringDataDefinition } from "../../../Common/Data/Definitions/StringDataDefinition";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class StringLowercaseExpression extends BaseStringExpression {
    readonly __type: string = "String Lowercase";
    readonly __ruleName: string = "Lower Case";
    value1: ExpressionValue;

    constructor() {
        super();

        this.value1 = ExpressionValue.createExpressionValue(this, "stringValue", new StringDataDefinition());
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        return this.value1.evaluate(data, testContext).toLowerCase();
    }
}
